module.exports = __webpack_public_path__ + "img/process_medium@2x.bba00bb4.webp";